import React from 'react';

const Hero: React.FC = () => {
  return (
    <div className="py-12 px-6 md:py-24 flex flex-col items-center justify-center text-center">
      <h1 className="text-white text-4xl md:text-6xl font-bold tracking-tight max-w-3xl mb-6 drop-shadow-lg">
        Quote Vibes Daily
      </h1>
      <h2 className="text-white text-2xl md:text-3xl font-semibold mb-6 drop-shadow-md">
        Motivation that fits your mood
      </h2>
      <p className="text-white text-xl md:text-2xl mb-10 max-w-2xl opacity-90 drop-shadow-md">
        Find the right words, right when you need them.
      </p>
      <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
          <a 
            href="https://apps.apple.com/us/app/quote-vibes-daily/id6744850119"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:opacity-90 transition-opacity duration-300"
          >
            <img 
              src="/app-store.svg.webp" 
              alt="Download on App Store" 
              className="h-14 md:h-16"
            />
          </a>
        </div>
      <div className="mt-8 text-white text-sm opacity-70">
        Free • Requires iOS 17.6 or later
      </div>
    </div>
  );
};

export default Hero; 